export default {
  common: {
    back: 'Back',
    cancel: 'Cancel',
    noBooking: 'Booking information not found',
    openFromBooking: 'Please open this page again from the booking details.',
    loadFailed: 'Failed to load',
    retry: 'Retry'
  },
  views: {
    change: {
      policy:
        'Changes are limited to trains on the same travel date before the original departure, subject to seat availability. You may change more than once. Stations and passenger count cannot be changed.',
      confirmSelect: 'Confirm change',
      submittedTitle: 'Reservation changed',
      submittedThanks: 'Return to the home page to check your updated ticket.'
    },
    trainList: {
      vehicleInfo: 'Train information',
      ticketName: 'Odakyu Romancecar',
      travelDate: 'Travel date: ',
      route: 'Departure and arrival: ',
      ticketCount: 'Passengers: ',
      trainType: 'Train type: ',
      seatClass: 'Seat class: ',
      preference: 'Seat preference: ',
      preOrderNote: '',
      selectStation: 'Select stations',
      from: 'From',
      to: 'To',
      swap: 'Swap departure and arrival stations',
      selectTrain: 'Select a train',
      select: 'Select',
      book: 'Book',
      seatAvailable: 'Seats available',
      seatLimited: 'Limited seats',
      soldOut: 'Sold out',
      notOnSale: 'Not on sale',
      noTimeRanges: 'No departure time ranges are available',
      noTrains: 'No trains are available in this time range'
    },
    seat: {
      title: 'Select seats',
      ticketCount: 'Passengers: ',
      selectMethod: 'Seat selection method',
      selectByPreference: 'Select by preference',
      selectBySeatMap: 'Select from seat map',
      preference: 'Position preference',
      car: 'Car',
      noCarPreference: 'No preference',
      selectSeats: 'Select seats ({{selected}}/{{total}})',
      seatLabel: 'Seat {{seat}}',
      seatMapDescription:
        '*Seats A/D are by the window and B/C are by the aisle. Seats cannot be selected across different cars.',
      noSeats: 'No seats are available in this car',
      noTrain: 'No train selected',
      selectTrainFirst: 'Go back and select a train.',
      next: 'Next'
    },
    confirm: {
      trainConfirm: 'Train Confirmation',
      ticketName: 'Odakyu Romancecar',
      route: 'Departure & Arrival: ',
      travelDate: 'Travel Date: ',
      ticketCount: 'Quantity: ',
      trainType: 'Train Type: ',
      seatClass: 'Seat Type: ',
      preference: 'Seat Preference: ',
      confirmSelect: 'Confirm Selection',
      noTrain: 'No train selected',
      selectTrainFirst: 'Go back and select a train.'
    },
    submitted: {
      title: 'Reservation Submitted',
      thanks:
        'Thank you for your booking. Please return to the home page to check the ticketing result.',
      ticketName: 'Odakyu Romancecar',
      route: 'Departure & Arrival: ',
      travelDate: 'Travel Date: ',
      ticketCount: 'Quantity: ',
      trainType: 'Train Type: ',
      seatClass: 'Seat Type: ',
      preference: 'Seat Preference: ',
      backHome: 'Back to Home'
    },
    notFound: {
      title: 'Page not found',
      message: 'Please check the URL and try again.'
    }
  }
};
